import { styled } from '@cherre-frontend/ui';

export const AddConnectorSkeletonContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const StepsSkeletonContainer = styled('div')`
  display: flex;
  gap: 32px;
  padding-left: 24px;
  padding-right: 24px;
  justify-content: center;
`;

export const ButtonsSkeletonContainer = styled('div')`
  padding-left: 24px;
  padding-right: 24px;
  margin-top: 32px;
  display: flex;
  justify-content: end;
  gap: 8px;
`;

export const BreadcrumbsSkeletonContainer = styled('div')`
  padding: 8px 16px;
`;

export const HeaderSkeletonContainer = styled('div')`
  margin-left: 24px;
  margin-right: 8px;
  display: flex;
  gap: 32px;
`;

export const ProgressSkeletonContainer = styled('div')`
  border-left: 1px solid ${({ theme }) => theme.palette.grey[400]};
  padding-left: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ProgressStepsSkeletonContainer = styled('div')`
  display: flex;
  gap: 8px;
`;
